import { render } from "./account.vue?vue&type=template&id=7f79ac1e"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=7f79ac1e&lang=less"
script.render = render

export default script